// 9fbef606107a605d69c0edbcd8029e5d
export const dyPageGroupTypes = {
  PDP: 'pdp_recs',
  PLP: 'plp_recs',
  ATB: 'atb_recs',
  CART: 'cart_recs',
  HOME: 'home_recs',
  ORDER: 'order_recs',
  GLOBAL: 'global_recs',
};

export const dyPageGroups = {
  PDP: [dyPageGroupTypes.PDP],
  PLP: [dyPageGroupTypes.PLP],
  CART: [dyPageGroupTypes.CART],
  HOME: [dyPageGroupTypes.HOME],
  ORDER: [dyPageGroupTypes.ORDER],
  GLOBAL: [dyPageGroupTypes.GLOBAL],
  ATB: [dyPageGroupTypes.ATB],
};

export const dyPageTypes = {
  CART: 'CART',
  PDP: 'PRODUCT',
  OTHER: 'OTHER',
  HOME: 'HOMEPAGE',
  CATEGORY: 'CATEGORY',
};

export const dyPageNames = {
  PDP: 'pdp',
  PLP: 'plp',
  CART: 'cart',
  HOME: 'home',
  ORDER: 'order_details',
  ATB: 'added_to_bag',
};

export const dySelectors = {
  pdp1: 'pdp1',
  pdp2: 'pdp2',
  pdpRecentlyViewed: 'pdpRecentlyViewed',
  ab_pdp_pla: 'ab_pdp_pla',
  ab_pdp_oos: 'ab_pdp_oos',
  added_to_bag1: 'added_to_bag1',
  cart1: 'cart1',
  cart2: 'cart2',
  homepage1: 'homepage1',
  order_details: 'order_details',
};
